'use client';

import { Suspense } from 'react';
import WebinarsContent from './WebinarsContent';

export default function WebinarsPage() {
  return (
    <Suspense fallback={
      <div style={{ minHeight: '100vh', background: '#060B14', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '32px', height: '32px', border: '2px solid #F97316', borderTopColor: 'transparent', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      </div>
    }>
      <WebinarsContent />
    </Suspense>
  );
}
